import { Contact } from '../models/contact.model';
var ContactComponent = /** @class */ (function () {
    function ContactComponent() {
        this.remarks = [];
    }
    Object.defineProperty(ContactComponent.prototype, "type", {
        get: function () {
            return Contact.formatContactType(this.contact.type);
        },
        enumerable: true,
        configurable: true
    });
    return ContactComponent;
}());
export { ContactComponent };
